var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"codics-factory-amdin-left",style:({ width: _vm.isCollapse ? '65px' : '270px' })},[_c('MenuTree',{ref:"leftMenu",attrs:{"is-collapse":_vm.isCollapse,"menuList":_vm.menuList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }